export type Document = any

export interface DocumentsState {
    loading: boolean
    resultdocument: string | { rejectedFiles: string[] } | null;
    documents: Document[]
    documentsForSelect: Document[]
    document: Document | null
    total: number

}

const initialState: DocumentsState = {
    loading: false,
    resultdocument: null,
    documents: [],
    documentsForSelect: [],
    document: null,
    total: 0,
}

export const documentsReducer = (state: DocumentsState = initialState, action: { type: string; payload?: any }): DocumentsState => {
    switch (action.type) {
        case 'DOCUMENT_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                documents: action.payload.documents as Document[],
                total: action.payload.total,
                resultdocument: null
            }

        case 'DOCUMENT_ADD_MULTIPLE_SUCCESS':
            return {
                ...state,
                loading: false,
                resultdocument: action.payload.message,
                documents: [...state.documents, action.payload.document as Document]
            }

        case 'DOCUMENT_DELETE_SUCCESS':
            return {
                ...state,
                loading: false,
                resultdocument: action.payload.message,
                documents: state.documents.filter(d =>
                    action.payload.documents
                        ? !(action.payload.documents.some((deleted: string) => deleted === d._id))
                        : true
                )
            }

        case 'DOCUMENT_RESET_RESULT':
            return {
                ...state,
                loading: false,
                resultdocument: null
            }

        case 'DOCUMENT_LOADING':
            return {
                ...state,
                loading: true
            }

        case 'DOCUMENT_NOT_LOADING':
            return {
                ...state,
                loading: false
            }

        default:
            return state
    }
}
